"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = NavigationHamburger;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _reactNative = require("react-native");
var _icons = require("@sart/icons");
var _excluded = ["state"];
function NavigationHamburger(props) {
  var state = props.state,
    rest = (0, _objectWithoutProperties2["default"])(props, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_reactNative.TouchableOpacity, rest, /*#__PURE__*/_react["default"].createElement(_icons.Menu, null));
}